<div fxLayout="column">

  <app-page-header [banner]="false" [section]="'Pay-out history'" [title]="'View automatic platform pay-outs'" [description]="'The pay-out history views allows you to see all the pay-outs made to you. Based on the date range selected you can view the payout status.'"></app-page-header>

  <app-payout-summary></app-payout-summary>

</div>
